/**
 * Cards!! (por algum motivo, repetido de src\components\ui\cards\SP360Card.vue)
 *  @descricao - Descrição na Base do Card
 *  @lgGrid - Tamanho do card no grid (>1000px, computadores)
 *  @mdGrid - Tamanho do card no grid (~1000px, tablets)
 *
 *  @tema - Estilo do card
 *  @tooltip - Texto tooltip
 *  @placement - posicionamento do tooltip: 'top', 'bottom', 'left', 'right'
 *  @valor - Valor principal do Card
 *  @sufix - Sufixo ao valor do card - Informação complementar/contextual
 *  @valorProgressBar - Valor no progressbar
*/

<template>
    <div :class="classes +' '+ gridSize">
        <sp-360-panel class="info-widget" :stripe="stripe" :class="level" :image="image" v-bind:enableTooltipOverflowX="false" :color="tema" :footerText="footerText">
            <div class="info-widget-inner has-chart">
                <!-- Dados internos do Card -->
                <div class="stats" v-if="checarValor(valor)">
                    <div class="stats-number">
                        <va-icon v-if="icon" :name="computedIcon" color="'success'" slot="prepend"/>
                        <span class="boldness">{{valorComputado}} {{sufix}}</span>
                        <div class="chart-container" v-if="valorProgressBar">
                          <va-progress-circle :key="progressKey" :value="valorProgressBar">
                            <span class="progress-bar-text"> {{ valorProgressBar }}% </span>
                          </va-progress-circle>
                        </div>
                    </div>
                    <div class="stats-title">
                        <span :class="classeDescricao">{{descricao}} </span>
                      <vuestic-tooltip v-if="tooltipComputado" :options="tooltipComputado">
                        <span class="fa fa-question-circle-o fa-lg toolTipHelp"></span>
                      </vuestic-tooltip>
                    </div>
                </div>
                <!-- Se os Status estiverem indefinidos no momento da renderização um spinner aparecerá -->
                <div class="stats" v-else>
                  <div>
                      <semipolar-spinner class="boldness empty-card" :animation-duration="2000" :size="50" :color="$themes.success" align="middle"/>
                  </div>
                </div>
            </div>
        </sp-360-panel>
    </div>
</template>

<script>
import MethGlob from '@/utils/MetodosGlobais'
import VuesticTooltip from '@/vuestic-theme/vuestic-components/vuestic-tooltip/VuesticTooltip'
import { SemipolarSpinner } from 'epic-spinners'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'

export default {
  name: 'sp-card',
  components: {
    VuesticTooltip,
    SemipolarSpinner,
    Sp360Panel,
  },
  data () {
    return {
      progressKey: 1,
      backgroundTheme: '',
      theme: '',
      tooltipCustom: 'vuestic-tooltip ',
      level: '',
    }
  },
  computed: {
    shape () {
      return this.classes + ' ' + this.gridSize()
    },
    gridSize () { return `md${this.mdGrid} lg${this.lgGrid} xl${this.lgGrid} xs12` },
    valorComputado () { return !isNaN(this.valor) ? MethGlob.thousandSeparator(this.valor) : this.valor },
    tooltipComputado () {
      let classes = this.tooltipCustom.concat(this.tooltipClasses)
      return this.tooltip ? { content: this.tooltip, placement: this.placement, classes: classes } : null
    },
    computedIcon () { return this.icon },
    classeDescricao () { return this.classDesc || '' },
  },

  props: {
    placement: {
      type: String,
      default: 'bottom',
    },
    descricao: {
      type: String,
      default: '',
    },
    classDesc: {
      type: String,
    },
    tema: {
      type: String,
    },
    valor: {
      default: 0,
    },
    sufix: {
      default: '',
      type: String,
    },
    tooltip: {
      type: String,
      default: null,
    },
    tooltipClasses: {
      type: String,
      default: '',
    },
    valorProgressBar: {
      type: Number,
      default: 0,
    },
    lgGrid: {
      type: Number,
      default: 3,
    },
    mdGrid: {
      type: Number,
      default: 6,
    },
    icon: {
      type: String,
      default: '',
    },
    image: {
      type: String,
    },
    stripe: {
      type: String,
      default: 'success',
    },
    footerText: {
      type: String,
    },
    classes: {
      type: String,
      default: 'flex',
    },
  },

  created () {
    // this._defineTema(this.tema)
  },

  methods: {
    reloadCard () {
      this.progressKey += 1
    },

    _defineTema (tema) {
      if (tema.toLowerCase() == 'danger') {
        this.theme = 'White'
        this.backgroundTheme = 'Danger'
        this.level = 'brand-danger'
        this.tooltipCustom = 'toolTipHelp-white'
      } else if (tema.toLowerCase() == 'info') {
        this.theme = 'White'
        this.backgroundTheme = 'Info'
        this.level = 'brand-info'
        this.tooltipCustom = 'toolTipHelp-white'
      } else {
        this.theme = 'Primary'
        this.backgroundTheme = 'White'
        this.level = ''
      }
    },
    checarValor (valor) {
      if (typeof valor === 'undefined' || valor === null) return false
      return true
    },
  },
}
</script>

<style lang="scss" scoped>
  .toolTipHelp-white{
     color: white;
     cursor: help;
  }

  .empty-card{
    text-align: center;
  }

  .boldness{
      font-size: 2.5vw;
      font-weight: 900;
      @include media-breakpoint-down(sm) {
        font-size: 7.5vw;
      }
  }

  .info-widget{
    padding-top: $card-padding;
  }

  .info-widget-inner {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    position: relative;
    width: 100%;
  }

  .disclaimer{
    display: block;
    text-align: right;
    font-style: italic;
    color:gray;
  }

  .card-tooltip-header{
    height: 10%;
  }

  .stats{
    width: 100%;
  }

  .stats-number{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    position: relative;
    width: 100%;
  }

</style>

<style lang="scss" scoped>
  .va-progress-circle{
    width: 3.125rem;
    height: 3.125rem;

    &__info {
      font-size: 0.75rem;
      font-weight: bold
    }
  }

  .progress-bar-text{
    font-size: 0.85rem;
    font-weight: bold
  }
</style>
